"use client";

import { useEffect } from "react";
import { captureException } from "@booboo.dev/js";

/** Next's route-level error boundary: it replaces the page whenever a render
 * throws, so this is the last place a marketing-site error is still ours to
 * report. BoobooInit has already run (it lives in the layout, which survives),
 * and captureException no-ops when no DSN is configured. */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-screen max-w-6xl flex-col items-center justify-center px-5 text-center">
      <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-fg-muted">
        Error
      </p>
      <h1 className="mt-3 text-3xl font-semibold tracking-[-0.02em] sm:text-4xl">
        Something went wrong
      </h1>
      <p className="mt-4 max-w-md text-[15px] leading-relaxed text-fg-muted">
        This page failed to load. We have been told about it — try again, and if
        it keeps happening the rest of the site is still fine.
      </p>
      <button
        type="button"
        onClick={reset}
        className="mt-7 inline-flex items-center rounded-md bg-accent px-4 py-2 text-sm font-medium text-[#06251A] transition-colors duration-200 hover:bg-accent-hover active:scale-[0.98]"
      >
        Try again
      </button>
    </main>
  );
}
